// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"719":"a6daf8f6","5836":"a6daf8f6","6848":"3ce294de"}[chunkId] + ".chunk.css";
};